import React from "react";

// export const Button = ({
//     label = "Submit",
//     onClick,
//     loading = false,
//     fullWidth = false,
// }) => {
//     return (
//         <button
//             onClick={onClick}
//             disabled={loading}
//             className={`${fullWidth ? "w-full" : ""
//                 } whitespace-nowrap bg-primary text-white shadow-lg transform scale-105 px-4 py-2 rounded hover:scale-110 transition-transform font-bold shadow-md mt-4 disabled:opacity-60 disabled:cursor-not-allowed`}
//         >
//             {loading ? (
//                 <>
//                     <span className="animate-spin inline-block mr-2 border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
//                     Processing...
//                 </>
//             ) : (
//                 label
//             )}
//         </button>
//     );
// };

export const Button = ({
    label = "Submit",
    type = "button",
    onClick,
    loading = false,
    fullWidth = false,
    className = "",
    disabled = false
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled === true ? disabled : loading}
            className={`
        ${fullWidth ? "w-full" : ""}
        whitespace-nowrap bg-primary text-white 
        transform scale-105 px-3 py-1.5 rounded 
        hover:scale-110 transition-transform shadow-md 
        disabled:opacity-60 disabled:cursor-not-allowed
        ${className}
      `}
        >
            {loading ? (
                <>
                    <span className="animate-spin inline-block mr-2 border-2 border-white border-t-transparent rounded-full w-4 h-4"></span>
                    Processing...
                </>
            ) : (
                label
            )}
        </button>
    );
};


export const SelectDropdown = ({ value, onChange, options = [] }) => {
    return (
        <div className="relative inline-block">
            <select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="whitespace-nowrap bg-primary text-white shadow-lg transform scale-105 px-4 py-2 pr-10 rounded hover:scale-110 transition-transform cursor-pointer appearance-none"
            >
                {options.map((opt, i) => (
                    <option
                        key={i}
                        value={opt.value}
                        className="text-black" // dropdown list ke liye black text
                    >
                        {opt.label}
                    </option>
                ))}
            </select>

            {/* Custom dropdown arrow */}
            <span className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-white">
                ▼
            </span>
        </div>
    );
};
